"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormDialog;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _CircularProgress;
var _excluded = ["Actions", "cancelButtonProps", "cancelKey", "cancelProps", "children", "confirmButtonProps", "confirmKey", "confirmProps", "disableContentPadding", "id", "onClose", "open", "titleKey", "titleProps", "submitting", "form", "handleSubmit"];
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    actions: {
      padding: theme.spacing(2, 3)
    },
    content: {
      overflowY: 'visible'
    },
    dialog: {
      overflowY: 'visible'
    },
    noContentPadding: {
      margin: theme.spacing(1, 0),
      padding: theme.spacing(0, 3)
    }
  };
});
function FormDialog(_ref) {
  var Actions = _ref.Actions,
    _ref$cancelButtonProp = _ref.cancelButtonProps,
    cancelButtonProps = _ref$cancelButtonProp === void 0 ? {} : _ref$cancelButtonProp,
    _ref$cancelKey = _ref.cancelKey,
    cancelKey = _ref$cancelKey === void 0 ? 'actions.cancel' : _ref$cancelKey,
    _ref$cancelProps = _ref.cancelProps,
    cancelProps = _ref$cancelProps === void 0 ? {} : _ref$cancelProps,
    children = _ref.children,
    _ref$confirmButtonPro = _ref.confirmButtonProps,
    confirmButtonProps = _ref$confirmButtonPro === void 0 ? {} : _ref$confirmButtonPro,
    _ref$confirmKey = _ref.confirmKey,
    confirmKey = _ref$confirmKey === void 0 ? 'actions.confirm' : _ref$confirmKey,
    _ref$confirmProps = _ref.confirmProps,
    confirmProps = _ref$confirmProps === void 0 ? {} : _ref$confirmProps,
    _ref$disableContentPa = _ref.disableContentPadding,
    disableContentPadding = _ref$disableContentPa === void 0 ? false : _ref$disableContentPa,
    id = _ref.id,
    onClose = _ref.onClose,
    open = _ref.open,
    titleKey = _ref.titleKey,
    _ref$titleProps = _ref.titleProps,
    titleProps = _ref$titleProps === void 0 ? {} : _ref$titleProps,
    submitting = _ref.submitting,
    form = _ref.form,
    handleSubmit = _ref.handleSubmit,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Dialog, (0, _extends2.default)({
    "aria-describedby": "".concat(id, "DialogContent"),
    "aria-labelledby": "".concat(id, "DialogTitle"),
    classes: {
      paperFullWidth: classes.dialog
    },
    fullWidth: true,
    maxWidth: "md",
    onClose: onClose,
    open: open
  }, other), /*#__PURE__*/_react.default.createElement("form", {
    form: form,
    id: id,
    onSubmit: handleSubmit
  }, titleKey && /*#__PURE__*/_react.default.createElement(_material.DialogTitle, {
    id: "".concat(id, "DialogTitle")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: titleKey,
    values: titleProps
  })), /*#__PURE__*/_react.default.createElement(_material.DialogContent, {
    classes: {
      root: (0, _classnames.default)(classes.content, disableContentPadding && classes.noContentPadding)
    },
    id: "".concat(id, "DialogContent")
  }, children), /*#__PURE__*/_react.default.createElement(_material.DialogActions, {
    className: classes.actions
  }, /*#__PURE__*/_react.default.createElement(_material.Button, (0, _extends2.default)({
    color: "default",
    id: "".concat(id, "CancelButton"),
    onClick: onClose,
    variant: "contained"
  }, cancelButtonProps), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: cancelKey,
    values: cancelProps
  })), Actions && /*#__PURE__*/_react.default.createElement(Actions, null), /*#__PURE__*/_react.default.createElement(_material.Button, (0, _extends2.default)({
    autoFocus: true,
    color: "primary",
    disabled: submitting,
    id: "".concat(id, "ConfirmButton"),
    startIcon: submitting && (_CircularProgress || (_CircularProgress = /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      color: "inherit",
      size: 20
    }))),
    type: "submit",
    variant: "contained"
  }, confirmButtonProps), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: confirmKey,
    values: confirmProps
  })))));
}